import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'

export const CompanyContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
`

export const CompanyJobs = styled.div`
  color: ${Colors.Neutral50};
  white-space: nowrap;
`
